import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, AuthContext } from '../App';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NotificationsPage = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }
    axios.get(`${API}/user/notifications`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setData(res.data))
      .catch((e) => setError(e.response?.data?.detail || 'Could not load notifications'));
  }, [token, navigate]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background)' }}>
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold" style={{ color: 'var(--primary)' }}>Notifications</h1>
        <p className="mt-3 text-gray-700 leading-relaxed">
          {data?.how_it_works || 'WhatsApp is used for alerts and payment OTPs. Email is used for overdue reminders. This page is the on-site record.'}
        </p>
        <ul className="mt-4 text-sm text-gray-600 list-disc pl-5 space-y-1">
          <li>Payment OTPs are sent on WhatsApp first, then SMS if WhatsApp is not configured.</li>
          <li>Book owners get a WhatsApp link to approve or decline a paid rental without logging in.</li>
          <li>Deposit added, withdrawal requested, order, payment, return, and book-added alerts use WhatsApp templates.</li>
          <li>Category alerts on Reading Preferences are saved for future digests; they do not replace order WhatsApp.</li>
        </ul>
        {error && <p className="mt-6 text-red-600">{error}</p>}
        <div className="mt-8 space-y-3">
          {(data?.items || []).length === 0 && !error && (
            <p className="text-gray-500">No alerts yet. New orders and deposit requests will show here.</p>
          )}
          {(data?.items || []).map((item) => (
            <div key={item.id} className="bg-white rounded-xl border p-4">
              <div className="flex justify-between gap-3">
                <p className="font-medium">{item.title}</p>
                <span className="text-xs uppercase text-gray-400">{item.channel || 'site'}</span>
              </div>
              <p className="text-sm text-gray-600 mt-1">{item.body}</p>
              {item.created_at && <p className="text-xs text-gray-400 mt-2">{String(item.created_at).replace('T', ' ').slice(0, 16)}</p>}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotificationsPage;
